/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Risk-Model-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 6/19/18
 * Copyright All Rights Reserved
 */
// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Nav, NavItem } from 'reactstrap';
import { footer as footerClass, navItem } from './index.module.scss';

const Footer = () => (
  <footer className={footerClass}>
    <Container>
      <Nav className="float-right">
        <NavItem className={navItem}>&copy; {(new Date()).getFullYear()} <a href="https://www.hbrisk.com" target="_blank" rel="noopener noreferrer">Haselton Baker Risk Group</a></NavItem>
        <NavItem className={navItem}>|</NavItem>
        <NavItem className={navItem}><a href="https://www.hbrisk.com/contact" target="_blank" rel="noopener noreferrer">Contact</a></NavItem>
        <NavItem className={navItem}>|</NavItem>
        <NavItem className={navItem}><Link to="/terms">Terms of Use</Link></NavItem>
      </Nav>
    </Container>
  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./js/components/support/layout/Footer/index.jsx